class UpdateOrganization {
	constructor(
		public readonly accountId: number,
		public readonly organizationId: number,
		public readonly name: string,
		public readonly siret: string | null,
		public readonly headOfficeAddress: string | null,
		public readonly documentFooterMentions: string | null,
	) {
		Object.freeze(this);
	}

	// `accountId` and `organizationId` are route identifiers: neither is echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			name: this.name,
			siret: this.siret,
			headOfficeAddress: this.headOfficeAddress,
			documentFooterMentions: this.documentFooterMentions,
		};
	}
}

export default UpdateOrganization;
